// Small per-row spouse tag for joint-policy projections. Renders nothing on
// single-life rows (no claimant). Rendered as plain colored text (no chip
// background) so it reads as a row label and doesn't compete visually with the
// adjacent milestone/event badges.
//
// Color pairing: client uses brand primary (`#7755CC`); partner uses
// Tailwind's orange-700 — a legible standalone orange (the brand accent
// `#F58A07` washes out as plain text on white).
export function ClaimantBadge({ claimant }: { claimant: MonthContext['claimant'] }) {
  if (claimant == null) return null;
  const isClient = claimant === 'client';
  return (
    <span
      className={`inline-flex shrink-0 items-center text-[9px] font-semibold uppercase tracking-wide ${
        isClient ? 'text-primary' : 'text-orange-700'
      }`}
    >
      {isClient ? 'Client' : 'Partner'}
    </span>
  );
}
